module.exports = __webpack_public_path__ + "static/footer-logos-abe3d01ac3334d4efdccc6f36ec39535.png";